const CONFIG = {
    back_domain: '',
    back_port: ''
};

export default CONFIG;

